
// Definición de defaults

export const defaultProceso: ProcesoProps = {
    idProceso:          0,
    descripcion:        '',
    siglas:             '',
    activo:             false,
}

// Creación de interfaces

export interface ProcesoProps {
    idProceso:              number;
    descripcion:         string;
    siglas:              string;
    activo:              boolean;
}